const handledMinimalCartExposureSessions = new Set<string>();

export const hasHandledMinimalCartExperimentExposureSession = (dedupeKey: string) =>
  handledMinimalCartExposureSessions.has(dedupeKey);

export const markMinimalCartExperimentExposureSessionHandled = (dedupeKey: string) => {
  handledMinimalCartExposureSessions.add(dedupeKey);
};

export const clearMinimalCartExperimentExposureSessions = () => {
  handledMinimalCartExposureSessions.clear();
};
